import styled from 'styled-components'

export const StyledSubtitle = styled.p`
  font-size: 1.6rem;
  color: #777;
  padding: 0;
  margin: 0.3rem 0;
  line-height: 24px;
`
